module.exports = __webpack_public_path__ + "img/2581135a4ed7c8fc6148fae1a9cd0569.jpg";